import initialState from './initialState'
import * as types from '../actions/actionTypes'

export default function requests(state = initialState.subscriptions, action: any) {
  switch (action.type) {
    case types.LOAD_SUBSCRIPTIONS_SUCCESS:
      return action.subscriptions;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/core/reducers/subscriptionReducer.tsx